import { FILTERS_QUERY_PARAMS } from '@constants/constants';
import { HotelDetailViewModel, HotelDetailReviewViewModel } from '@api/index';

import { ListingMetaViewModel } from './types';

export type HotelDetailTabProps = {
  key: string;
  title: string;
};

export const hotelDetailTabs: HotelDetailTabProps[] = [
  { key: 'overview', title: 'Genel Bakış' },
  { key: 'features', title: 'Özellikler' },
  { key: 'rooms', title: 'Odalar' },
  { key: 'rules', title: 'Kurallar' },
  { key: 'about', title: 'Hakkıda' },
  { key: 'location', title: 'Konum' },
  { key: 'announcements', title: 'Duyurular' },
  { key: 'scoring', title: 'Puan ve Yorumlar' },
];

export const getPaginationUrlLinksForGoogleRobots = (
  meta: ListingMetaViewModel
) => {
  const nextVisitedLinks: string[] = [];
  const canonicalPath =
    window.location.href + '&rel=canonical&sayfa=' + meta.currentPage;
  nextVisitedLinks.push(canonicalPath);

  if (meta.hasNextPage) {
    const nextPath =
      window.location.href + '&rel=next&sayfa=' + (meta.currentPage + 1);
    nextVisitedLinks.push(nextPath);
  }
  if (meta.currentPage > 1) {
    const prevPath =
      window.location.href + '&rel=prev&sayfa=' + (meta.currentPage - 1);
    nextVisitedLinks.push(prevPath);
  }

  return nextVisitedLinks;
};

export const isEmptyFilters = (query) => {
  let isEmpty = true;

  for (const item of FILTERS_QUERY_PARAMS) {
    if (item in query) {
      isEmpty = false;
    }
  }

  return isEmpty;
};

export const prepareStickyTabs = (
  hotelData?: HotelDetailViewModel,
  tripAdvisorDetail?: HotelDetailReviewViewModel
): HotelDetailTabProps[] => {
  const preparedStickyTabs: HotelDetailTabProps[] = [];

  const overview = hotelDetailTabs.find((tab) => tab.key === 'overview');
  preparedStickyTabs.push(overview as HotelDetailTabProps);

  const rooms = hotelDetailTabs.find((tab) => tab.key === 'rooms');
  preparedStickyTabs.push(rooms as HotelDetailTabProps);

  if (hotelData?.features?.length) {
    const features = hotelDetailTabs.find((tab) => tab.key === 'features');
    preparedStickyTabs.push(features as HotelDetailTabProps);
  }

  if (hotelData?.checkinBeginTime) {
    const rules = hotelDetailTabs.find((tab) => tab.key === 'rules');
    preparedStickyTabs.push(rules as HotelDetailTabProps);
  }

  if (hotelData?.description) {
    const about = hotelDetailTabs.find((tab) => tab.key === 'about');
    preparedStickyTabs.push(about as HotelDetailTabProps);
  }
  if (hotelData?.announcements && hotelData?.announcements?.length > 0) {
    const announcements = hotelDetailTabs.find(
      (tab) => tab.key === 'announcements'
    );
    preparedStickyTabs.push(announcements as HotelDetailTabProps);
  }

  if (hotelData?.latitude && hotelData?.longitude) {
    const location = hotelDetailTabs.find((tab) => tab.key === 'location');
    preparedStickyTabs.push(location as HotelDetailTabProps);
  }
  if (tripAdvisorDetail?.rating || 0 > 3) {
    const scoring = hotelDetailTabs.find((tab) => tab.key === 'scoring');
    preparedStickyTabs.push(scoring as HotelDetailTabProps);
  }

  return preparedStickyTabs as HotelDetailTabProps[];
};
